import $ from "jquery";

const dropdowns = $(".dropdown__header");

// Основная логика клика
$("body").on("click", (e) => {
  if ($(e.target).closest(".js-open-drawer").length) {
    return;
  }

  dropdowns?.each(function () {
    const $dropdown = $(this);
    const $dropdownBody = $dropdown.next();
    const $dropdownItems = $dropdownBody.find("li");
    const $dropdownHeaderText = $dropdown.find("span");
    const $dropdownInput = $dropdownBody.find("input");
    const headerSearch = localStorage.getItem("headerSearch");

    // ✅ Если есть сохранённое значение, показываем его при рендере
    if (
      headerSearch &&
      $dropdown.parent().hasClass("header__search-dropdown")
    ) {
      const $savedItem = $dropdownItems.filter(`[data-key="${headerSearch}"]`);
      if ($savedItem.length) {
        $dropdownHeaderText.text($savedItem.text());
        $dropdownHeaderText[0].dataset.key = headerSearch;
        if ($dropdownInput.length) {
          $dropdownInput.val(headerSearch);
        }
      }
    }

    if ($dropdownBody.has(e.target).length && $(e.target).hasClass("item")) {
      // ✅ Меняем текст в span на текст выбранного li
      const selectedKey = $(e.target).data("key");
      const selectedText = $(e.target).text();

      if ($dropdown.parent().hasClass("header__search-dropdown")) {
        localStorage.setItem("headerSearch", selectedKey);
      }

      $dropdownHeaderText.text(selectedText);
      $dropdownHeaderText[0].dataset.key = selectedKey;

      if ($dropdownInput.length) {
        $dropdownInput.val(selectedKey).trigger("change");

        // ⬅️ если подключён jquery-validate
        if ($dropdownInput.closest("form").length) {
          $dropdownInput.valid();
        }
      }
      // ✅ Закрываем выпадающий список после выбора
      $dropdown.removeClass("active");
      $dropdownBody.removeClass("show");
    } else if ($dropdown.is(e.target) || $dropdown.has(e.target).length) {
      // Закрываем все дропдауны, кроме текущего
      dropdowns.not($dropdown).next().removeClass("show");

      // Тогглим класс у текущего дропдауна
      $dropdown.toggleClass("active");
      $dropdownBody.toggleClass("show");
    } else {
      // Закрываем дропдаун если клик вне dropdown-а
      $dropdown.removeClass("active");
      $dropdownBody.removeClass("show");
    }
  });
});

// ✅ Функция проверки
function checkRequired(dropdown, input) {
  const required = $(dropdown).data("required");
  return required ? $(input).val() !== "" : true;
}

// ✅ Запускаем проверку сразу после загрузки
$(document).ready(() => {
  dropdowns.each(function () {
    const $dropdown = $(this);
    const $dropdownBody = $dropdown.next();
    const $dropdownInput = $dropdownBody.find("input");
    const $dropdownItems = $dropdownBody.find("li");
    const $dropdownHeaderText = $dropdown.find("span");
    const headerSearch = localStorage.getItem("headerSearch");

    if (
      headerSearch &&
      $dropdown.parent().hasClass("header__search-dropdown")
    ) {
      const $savedItem = $dropdownItems.filter(`[data-key="${headerSearch}"]`);
      if ($savedItem.length) {
        $dropdownHeaderText.text($savedItem.text());
        $dropdownHeaderText[0].dataset.key = headerSearch;
        if ($dropdownInput.length) {
          $dropdownInput.val(headerSearch);
        }
      }
    }
  });
});
